import call_user_func from "locutus/php/funchand/call_user_func"

export default {
	data(){
		return {
			state: 'initial'
		}
	},
	props: {
		toast: {
			type: Object,
			required: true
		}
	},
	created(){
		this.startTimer()
	},	
	methods: {
		startTimer(){
			this.timer = setInterval(() => {
				this.toast.progress = this.getProgress()
				if(this.toast.end_date < new Date()){
					this.closeToast()
				}
			}, 10)
		},
		closeToast(){
			clearInterval(this.timer)
			this.$store.dispatch('remove_toast', this.toast.index)
		},
		getProgress(){
			let timeout = this.toast.end_date.getTime() - this.toast.date.getTime()
			let progress = 100 - Math.round((this.toast.end_date.getTime() - new Date().getTime()) / timeout * 100) 
			return progress
		}
	},
	computed:{
	},
	components:{
		
	}
}